<template>
<v-card>
  <close-dialog :close-dialog="closeDialog" />

  <div class="options-container">
    <v-card-title primary-title>
      <h3 class="headline mb-0">
        {{ $vuetify.t('$vuetify.account.editTitle') }}
      </h3>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <v-flex md6 xs12 :style="$vuetify.breakpoint.smAndUp ? 'padding-right: 10px' : null">
          <v-text-field
            name="firstName"
            v-model="payload.firstName"
            :label="$vuetify.t('$vuetify.common.firstName')"
            v-validate="'required'"
            :data-vv-as="$vuetify.t('$vuetify.common.firstName').toLowerCase()"
            :error-messages="errors.collect('firstName')"
          />
        </v-flex>

        <v-flex md6 xs12 :style="$vuetify.breakpoint.smAndUp ? 'padding-left: 10px' : null">
          <v-text-field
            name="lastName"
            v-model="payload.lastName"
            :label="$vuetify.t('$vuetify.common.lastName')"
            v-validate="'required'"
            :data-vv-as="$vuetify.t('$vuetify.common.lastName').toLowerCase()"
            :error-messages="errors.collect('lastName')"
          />
        </v-flex>
      </v-layout>

      <v-text-field
        name="email"
        v-model="payload.email"
        :label="$vuetify.t('$vuetify.common.email')"
        v-validate="'required|email'"
        data-vv-as="email"
        :error-messages="errors.collect('email')"
      />
    </v-card-text>
  </div>

  <v-card-actions>
    <v-btn color="primary" @click="save" id="saveAction">
      {{ $vuetify.t('$vuetify.common.save') }}
    </v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import CloseDialog from "@/components/Common/CloseDialog"

export default {
  components: { CloseDialog },

  data: () => ({
    payload: {
      firstName: null,
      lastName: null,
      email: null
    }
  }),

  computed: {
    customer() {
      return this.getCustomer || {}
    },

    ...mapGetters([ 'getCustomer', 'getCheckoutInfo' ])
  },

  methods: {
    setDefault() {
      this.payload.firstName = this.customer.firstName
      this.payload.lastName = this.customer.lastName
      this.payload.email = this.customer.email
    },

    closeDialog(reset = true) {
      // We don't want to reset when using save button, only close
      if (reset)
        this.setDefault()
      this.$parent.$parent.$parent.$parent.editDetails = false
    },

    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$api.post('/customer', this.payload).then(() => {
            this.fetchAccountDetails(this.$route.params.sid).then(() => {
              this.closeDialog(false)

              // Also update their information in the checkout form since that is cached
              this.SET_CHECKOUT_INFO({
                ...this.getCheckoutInfo,
                firstname: this.payload.firstName,
                lastname: this.payload.lastName,
                email: this.payload.email
              })

              this.showSnack({
                text: this.$vuetify.t('$vuetify.common.changesSaved'),
                color: 'success'
              })
            })
          })
        } else {
          this.showSnack({
            text: this.$vuetify.t('$vuetify.common.fillFields'),
            color: 'error'
          })
        }
      })
    },

    ...mapMutations([ 'SET_CHECKOUT_INFO' ]),
    ...mapActions([ 'fetchAccountDetails', 'showSnack' ])
  },

  mounted() {
    this.setDefault()
  }
}
</script>

<style scoped>
  .v-card__title,
  .v-card__text {
    padding: 25px 48px 10px;
  }

  #saveAction {
    width: calc(100% - 48px - 48px + 16px);
    margin: auto;
  }

  .options-container {
    height: auto !important;
  }
  .menu-config-dialog.v-dialog--fullscreen .options-container {
    padding: 0px !important
  }
  .menu-config-dialog.v-dialog--fullscreen .options-container .v-card__title,
  .menu-config-dialog.v-dialog--fullscreen .options-container .v-card__text {
    padding: 25px 36px 10px;
  }
</style>
